export default __webpack_public_path__ + "static/media/thankyoukeyvis_tickets_tab@2x.a2ded7ef.png";